import { render } from "./Header.vue?vue&type=template&id=33e60134&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=33e60134&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33e60134"

export default script